import { useObservable } from "micro-observables";
import { useServices } from "@core/servicesContext";
import { ProfileRole } from "@domain/user/profile";
import { Person } from "@domain/user/user";
import { CurrentProfile } from "./currentProfile";
import { InitializationState } from "./initializationState";
import { RegisterState } from "./registerState";

export function useCurrentProfile(): CurrentProfile | null {
	const { currentProfileService } = useServices();
	return useObservable(currentProfileService.currentProfile);
}

export function useCurrentProfileInitialization(): InitializationState {
	const { currentProfileService } = useServices();
	return useObservable(currentProfileService.initialization);
}

export function useRegisterState(): RegisterState {
	const { currentProfileService } = useServices();
	return useObservable(currentProfileService.registerState);
}

export function useOrganizationAlias(): Person | null {
	const { currentProfileService } = useServices();
	return useObservable(currentProfileService.organizationAlias);
}

export function useIsPerson(person: { id?: string }): boolean {
	const organizationAlias = useOrganizationAlias();
	const currentProfile = useCurrentProfile();

	if (organizationAlias) {
		return organizationAlias.id === person.id;
	}
	return currentProfile?.id === person.id;
}

export function useIsAdmin(): boolean {
	const currentProfile = useCurrentProfile();
	return !!currentProfile?.adminRoles?.find((role) => role === "ADMIN" || role === "SYS_ADMIN");
}

export function useProfileRole(): ProfileRole | undefined {
	const currentProfile = useCurrentProfile();
	return currentProfile?.customData?.profileRole ?? currentProfile?.profileRole;
}

export function useIsLearner(): boolean {
	return useProfileRole() === "LEARNER";
}
